import LinkButton, { LinkButtonProps } from './LinkButton'
import { createReactCustomElement } from '../CustomElement'

createReactCustomElement<LinkButtonProps>('link-button', LinkButton)
